import { useState } from 'react';
import type { SoQuyTienMatRequest } from '@/types/schemas';
import { useAuth } from '@/contexts/auth-context';
import { toast } from '@/hooks/use-toast';

export const useSoQuyTienMatExport = (body: Partial<SoQuyTienMatRequest> = {}) => {
  const [isExporting, setIsExporting] = useState(false);
  const { entity } = useAuth();

  const exportToExcel = async () => {
    setIsExporting(true);
    try {
      const { exportSoQuyTienMatFromApi } = await import('../utils/excel-export');
      if (!entity?.slug) {
        toast({
          description: 'Không tìm thấy thông tin đơn vị.',
          variant: 'default'
        });
        return;
      }

      await exportSoQuyTienMatFromApi({
        entitySlug: entity.slug,
        body
      });
    } catch (error) {
      toast({
        description: 'Không thể kết xuất dữ liệu.',
        variant: 'destructive'
      });
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportToExcel,
    canExport: Boolean(entity?.slug),
    isExporting
  };
};
